
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Patientforcedairwarmingdelhi() {



  const cardData =
  {
    keyword: 'Patient Forced Air Warming Blankets in Delhi',
    heading: 'Pharmacle Health Care Private Limited: Patient Forced Air Warming Blankets in Delhi',
    headingDescription: 'Pharmacle Health Care Private Limited provides high-quality Patient Forced Air Warming Blankets in Delhi, ensuring effective temperature management for surgical and critical care patients. Our Wallabies Warm Care blankets are designed for even heat distribution, reducing the risk of hypothermia and improving patient comfort. Used in hospitals and healthcare facilities, these forced air warming blankets are reliable, safe, and easy to use. With advanced materials and superior technology, we help enhance patient care and recovery. Choose Pharmacle Health Care for the best air warming blankets in Delhi.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',

    "topPlaces": [
        {
          "title": "Patient Forced Air Warming Blankets",
          "description": "Wallabies Warm Care provides high-quality Patient Forced Air Warming Blankets in Delhi, designed to maintain optimal body temperature during medical procedures. Our blankets ensure even heat distribution, reducing the risk of hypothermia in surgical and ICU patients. These advanced solutions enhance patient comfort and recovery."
        },
        {
          "title": "Surgical Warming Blankets",
          "description": "Our Surgical Warming Blankets are specifically designed for operating rooms, ensuring stable and controlled warming throughout surgical procedures. They help in preventing perioperative hypothermia, leading to improved surgical outcomes and faster recovery times."
        },
        {
          "title": "Pediatric Forced Air Warming Blankets",
          "description": "Wallabies Warm Care offers specially crafted Pediatric Forced Air Warming Blankets for newborns and children. These hypoallergenic, soft, and effective blankets provide gentle warmth, ensuring comfort and safety during medical treatments."
        },
        {
          "title": "Disposable Warming Blankets",
          "description": "Our Disposable Forced Air Warming Blankets provide a hygienic and effective solution for maintaining patient warmth. Ideal for single-use applications in hospitals and clinics, these blankets minimize the risk of cross-contamination while offering superior thermal care."
        },
        {
          "title": "ICU Patient Warming Blankets",
          "description": "Designed for critical care units, our ICU Patient Warming Blankets deliver precise temperature control to support patients in intensive care. These blankets help stabilize core body temperature, reducing the risk of complications related to hypothermia."
        },
        {
          "title": "Emergency Patient Warming Blankets",
          "description": "Wallabies Warm Care offers Emergency Patient Warming Blankets for trauma care and emergency response teams. These blankets provide rapid warming for patients in shock or hypothermic conditions, making them essential for ambulances and emergency rooms."
        },
        {
          "title": "Veterinary Warming Blankets",
          "description": "Our Veterinary Forced Air Warming Blankets are designed for animal care, providing gentle and effective heating for pets and livestock undergoing medical procedures. These blankets ensure optimal warmth and comfort for animals in veterinary clinics."
        },
        {
          "title": "Portable Forced Air Warming Blankets",
          "description": "Our Portable Forced Air Warming Blankets are lightweight and easy to use, making them perfect for ambulances, home care, and post-surgical recovery. They offer reliable and consistent warming, improving patient outcomes in various healthcare settings."
        },
        {
          "title": "Advanced Temperature-Controlled Warming Blankets",
          "description": "Wallabies Warm Care introduces state-of-the-art Advanced Temperature-Controlled Warming Blankets with precise heat regulation for medical and surgical applications. These innovative blankets ensure patient safety and comfort with their adaptive warming technology."
        },
        {
          "title": "Preoperative Patient Warming Blankets",
          "description": "Our Preoperative Patient Warming Blankets help maintain normothermia before surgery, reducing the risk of postoperative complications. These blankets provide effective thermal management, ensuring better surgical results and enhanced patient recovery."
        }
      ],


"services": [
    {
        "name": "Patient Forced Air Warming Blankets Delhi",
        "description": "Pharmacle Health Care Private Limited offers high-quality patient forced air warming blankets in Delhi. Designed to provide consistent warmth, these blankets prevent hypothermia and ensure patient safety during surgeries and medical treatments."
    },
    {
        "name": "Delhi Patient Warming Blankets",
        "description": "Our patient warming blankets in Delhi are specifically designed to maintain a stable body temperature for patients during surgeries, emergency care, and post-operative recovery, ensuring maximum comfort and safety."
    },
    {
        "name": "Forced Air Warming Blanket Delhi",
        "description": "Pharmacle Health Care supplies forced air warming blankets in Delhi, offering reliable temperature control for patient care. These blankets are essential for preventing hypothermia and ensuring a comfortable recovery in medical environments."
    },
    {
        "name": "Patient Warming Systems in Delhi",
        "description": "We provide advanced patient warming systems in Delhi, designed to regulate body temperature effectively during surgeries and critical care procedures. These systems ensure that patients are kept at a comfortable and safe temperature throughout their treatment."
    },
    {
        "name": "Delhi Medical Warming Blankets",
        "description": "Our medical warming blankets in Delhi are perfect for surgical and critical care environments, ensuring that patients maintain a steady body temperature, preventing complications and improving patient outcomes."
    },
    {
        "name": "Warming Blankets Supplier in Delhi",
        "description": "Pharmacle Health Care is a trusted warming blankets supplier in Delhi. We offer high-quality patient warming blankets that are designed for optimal performance and durability in hospital and clinical settings."
    },
    {
        "name": "Forced Air Warming Blanket Supplier",
        "description": "As a leading forced air warming blanket supplier, Pharmacle Health Care delivers reliable, safe, and effective warming solutions in Delhi. Our blankets are designed to deliver consistent warmth to patients, ensuring comfort and safety during medical procedures."
    },
    {
        "name": "Patient Warming Solutions Delhi",
        "description": "We offer a variety of patient warming solutions in Delhi, including forced air warming blankets, temperature regulation systems, and devices that ensure safe and comfortable patient care throughout medical treatments."
    },
    {
        "name": "Delhi Patient Temperature Regulation Blankets",
        "description": "Our patient temperature regulation blankets in Delhi are designed to maintain a controlled and comfortable body temperature for patients undergoing medical procedures, ensuring optimal outcomes and preventing hypothermia."
    },
    {
        "name": "Delhi Surgical Warming Blankets",
        "description": "Pharmacle Health Care supplies surgical warming blankets in Delhi, essential for preventing intraoperative hypothermia. These blankets provide controlled warmth during surgeries, helping to improve recovery and patient safety."
    }
],
"tableData": [
    ["- Patient Forced Air Warming Blankets Delhi", "- Delhi Patient Warming Blankets"],
    ["- Forced Air Warming Blanket Delhi", "- Patient Warming Systems in Delhi"],
    ["- Delhi Medical Warming Blankets", "- Warming Blankets Supplier in Delhi"],
    ["- Forced Air Warming Blanket Supplier", "- Patient Warming Solutions Delhi"],
    ["- Delhi Patient Temperature Regulation Blankets", "- Delhi Surgical Warming Blankets"]
],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers state-of-the-art forced air warming systems and blankets in Delhi, designed for precise temperature control during medical treatments. Our technology ensures reliable performance to prevent hypothermia, promoting patient safety in hospitals and clinics across the region."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a wide range of patient warming solutions, including forced air warming devices and blankets in Delhi. Our products cater to both surgical procedures and critical care, ensuring your patients remain comfortable and safe throughout their medical treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our patient warming equipment is manufactured to the highest quality standards, ensuring durability and long-lasting performance. Designed for continuous use in medical environments, our products undergo rigorous testing and regular servicing to ensure reliable operation in Delhi hospitals and clinics."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient comfort and safety are our primary focus. Our forced air warming blankets and devices deliver controlled, gentle warmth, preventing temperature-related complications during surgeries and procedures. Patients in Delhi can trust that they are in safe hands with our warming solutions."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our patient warming systems are adaptable to various healthcare settings in Delhi, including hospitals, clinics, and emergency rooms. We collaborate closely with healthcare providers to ensure our systems are tailored to meet the specific needs of their patients."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care's patient warming solutions are designed for seamless integration with existing medical systems in Delhi. Our products can be easily incorporated without disrupting ongoing medical procedures, ensuring efficiency for healthcare professionals."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "Our team in Delhi offers expert consultation to help healthcare facilities choose the right warming solutions. We provide ongoing support and maintenance services, ensuring that your equipment remains in peak condition for the safety and comfort of your patients."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, we prioritize patient safety and comfort. Our warming systems are designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient is treated with the highest standards of care in Delhi."
    }
]





  }




  const faqData = [
    { question: "What are Patient Forced Air Warming Blankets?", answer: "Patient Forced Air Warming Blankets are specially designed blankets that provide controlled warm air to maintain the patient's body temperature during medical procedures and treatments." },
    { question: "How do Patient Forced Air Warming Blankets work?", answer: "These blankets work by circulating warm air through the blanket, which helps to prevent hypothermia and maintain normothermia during surgeries or other medical interventions." },
    { question: "Are Patient Forced Air Warming Blankets available in Delhi?", answer: "Yes, we offer our high-quality Patient Forced Air Warming Blankets in Delhi through Pharmacle Health Care Private Limited." },
    { question: "What are the benefits of using Patient Forced Air Warming Blankets?", answer: "They help in preventing hypothermia, enhancing patient comfort, reducing surgical site infections, and improving patient recovery times." },
    { question: "How long can a Patient Forced Air Warming Blanket be used?", answer: "The blanket can be used throughout the duration of the procedure to ensure the patient remains warm and comfortable until the procedure is completed." },
    { question: "Are the Patient Forced Air Warming Blankets reusable?", answer: "Yes, the blankets are designed to be reusable, but they must be properly cleaned and sanitized according to the guidelines provided." },
    { question: "Is the Patient Forced Air Warming Blanket safe for all patients?", answer: "Yes, our blankets are safe for most patients. However, they should be used as directed, particularly for patients with certain medical conditions, under professional supervision." },
    { question: "How do I order Patient Forced Air Warming Blankets in Delhi?", answer: "You can contact Pharmacle Health Care Private Limited directly for ordering and delivery in Delhi. Our team will assist you with the process." },
    { question: "Can the Patient Forced Air Warming Blanket be used in all types of surgeries?", answer: "Yes, the blanket can be used for a variety of surgical procedures and medical treatments where temperature regulation is crucial." },
    { question: "Does Pharmacle Health Care offer support for the Patient Forced Air Warming Blankets?", answer: "Yes, we provide full support, including installation, training, and maintenance services for our Patient Forced Air Warming Blankets." }
  ];
  
  const testimonialsData = [
    {
      text: 'We have been using the Patient Forced Air Warming Blankets from Pharmacle Health Care in our clinic in Delhi. The blankets are easy to use and have significantly improved patient comfort during our procedures.',
      name: 'Dr. Shweta Kumar',
    },
    {
      text: 'Pharmacle Health Care’s Patient Forced Air Warming Blankets have helped maintain ideal body temperature for our patients during surgeries, reducing post-operative complications. We highly recommend their products.',
      name: 'Dr. Amit Desai',
    }
  ];
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Patient Forced Air Warming Blankets in Delhi",
    "description": "Discover high-quality Patient Forced Air Warming Blankets in Delhi for effective patient temperature regulation during surgeries and treatments. Our blankets ensure optimal warmth and comfort in medical settings.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.9",
      "ratingCount": "1658"
    }
  };
  


  return (
    <div>
  <Helmet>
    <title>Patient Forced Air Warming Blankets in Delhi | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Discover high-quality Patient Forced Air Warming Blankets in Delhi for patient temperature regulation during surgeries and treatments. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Patient Forced Air Warming Blankets Delhi, Delhi Patient Warming Blankets, Forced Air Warming Blanket Delhi, Patient Warming Systems in Delhi, Delhi Medical Warming Blankets, Warming Blankets Supplier in Delhi, Forced Air Warming Blanket Supplier, Patient Warming Solutions Delhi, Delhi Patient Temperature Regulation Blankets, Delhi Surgical Warming Blankets"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/2.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Navar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Patientforcedairwarmingdelhi;